/* Native links and details remain usable without JavaScript. */
if (!customElements.get('brinborg-navigation')) {
  customElements.define('brinborg-navigation', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(()=>this.setup());
    }
    setup() {
      if(!this.isConnected || this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      document.addEventListener('shopify:cart:lines-update',event=>{
        event.promise?.then(({cart,detail})=>{
          const count=cart?.totalQuantity ?? detail?.itemCount;
          if(Number.isFinite(count)){
            const badge=this.querySelector('.bb-cart__count');
            if(badge) badge.textContent=String(count);
          }
        }).catch(()=>{});
      },options);
      const hover = matchMedia('(hover:hover) and (pointer:fine) and (min-width:750px)');
      this.menuTimers = new Map();
      const menus = [...this.querySelectorAll('.bb-dropdown, .bb-children-menu')];
      menus.forEach(detail => {
        const summary = detail.querySelector(':scope > summary');
        const sync = () => summary.setAttribute('aria-expanded', String(detail.open));
        const close = () => {
          detail.open = false;
          detail.querySelectorAll('details[open]').forEach(child => child.open = false);
        };
        sync();
        detail.addEventListener('toggle', () => {sync();if(!detail.open) detail.querySelectorAll('details[open]').forEach(child => child.open = false);}, options);
        detail.addEventListener('pointerenter', () => {
          if(hover.matches){clearTimeout(this.menuTimers.get(detail));detail.open=true;}
        }, options);
        detail.addEventListener('pointerleave', () => {
          if(hover.matches) this.menuTimers.set(detail,setTimeout(() => {
            if(!detail.contains(document.activeElement)) close();
          },160));
        }, options);
        detail.addEventListener('focusout', () => {
          this.menuTimers.set(detail,setTimeout(() => {
            if(!detail.contains(document.activeElement)&&!detail.matches(':hover')) close();
          },0));
        }, options);
        detail.addEventListener('keydown', e => {
          if(e.key==='Escape'&&detail.open){e.stopPropagation();e.preventDefault();close();summary.focus();}
        }, options);
        document.addEventListener('click', e => {if(!detail.contains(e.target)) close();}, options);
      });
    }
    disconnectedCallback(){this.menuTimers?.forEach(timer=>clearTimeout(timer));this.menuTimers?.clear();this.abort?.abort();this.abort=null;}
  });
}
// File stays on the device for preview; Shopify receives it only on form submission.
if (!customElements.get('brinborg-print-form')) {
  customElements.define('brinborg-print-form', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(()=>this.setup());
    }
    setup() {
      if(!this.isConnected || this.abort) return;
      this.abort=new AbortController();
      const input=this.querySelector('[data-print-file]');
      if(!input) return;
      const img=this.querySelector('[data-print-preview]');
      const figure=this.querySelector('.bb-upload-preview');
      const status=this.querySelector('.bb-upload-status');
      const form=this.querySelector('form');
      const filename=this.querySelector('[data-file-name]');
      input.addEventListener('change',()=>{
        if(this.previewUrl)URL.revokeObjectURL(this.previewUrl);
        this.previewUrl=null;figure.hidden=true;img.removeAttribute('src');input.setCustomValidity('');
        if(filename)filename.textContent='Intet billede valgt';
        const file=input.files?.[0];if(!file){status.textContent='';return;}
        const validTypes=['image/jpeg','image/png','image/webp'];
        if(!validTypes.includes(file.type)||file.size>20*1024*1024||file.size===0){
          const message=file.size>20*1024*1024?'Billedet er større end 20 MB. Vælg en mindre fil, eller kontakt os.':'Vælg et gyldigt JPG-, PNG- eller WebP-billede.';
          input.value='';input.setCustomValidity(message);status.textContent=message;input.reportValidity();return;
        }
        if(filename)filename.textContent=file.name;
        this.previewUrl=URL.createObjectURL(file);img.src=this.previewUrl;figure.hidden=false;
        status.textContent=`Valgt: ${file.name}. Billedet uploades, når du lægger varen i kurven.`;
      },{signal:this.abort.signal});
      form.addEventListener('submit',()=>{status.textContent='Dit billede uploades. Vent, til indkøbskurven åbner.';},{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;if(this.previewUrl)URL.revokeObjectURL(this.previewUrl);}
  });
}
